import PropTypes from 'prop-types';
import { usePendingSearch } from './PendingSearchContext';
import { matchPendingTotalPrice } from './pendingOrderKeywordMatch';
import formatCurrency from '../../../../utils/formatCurrency';

const escapeRegExp = (value) => String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** 在文案中高亮当前待办搜索关键词（大小写不敏感） */
export const PendingKeywordHighlight = ({ text, fallback = '-' }) => {
	const { keyword } = usePendingSearch();
	const display = text == null || text === '' ? fallback : String(text);
	const q = String(keyword ?? '').trim();
	if (!q || display === fallback) {
		return display;
	}

	const re = new RegExp(`(${escapeRegExp(q)})`, 'gi');
	const parts = display.split(re);
	if (parts.length <= 1) {
		return display;
	}

	return parts.map((part, index) =>
		part && part.toLowerCase() === q.toLowerCase() ? (
			<mark key={`hk-${index}`} className='pending-keyword-mark'>
				{part}
			</mark>
		) : (
			part
		),
	);
};

PendingKeywordHighlight.propTypes = {
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	fallback: PropTypes.string,
};

/** 金额列：命中关键词时整格高亮（格式化后难做子串匹配） */
export const PendingAmountHighlight = ({ amount, className }) => {
	const { keyword } = usePendingSearch();
	const label = formatCurrency(amount);
	const hit = matchPendingTotalPrice(amount, keyword);
	if (!hit) {
		return className ? <span className={className}>{label}</span> : label;
	}
	return <mark className={className ? `pending-keyword-mark ${className}` : 'pending-keyword-mark'}>{label}</mark>;
};

PendingAmountHighlight.propTypes = {
	amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	className: PropTypes.string,
};

export const PendingTotalPriceHighlight = ({ totalPrice, className }) => (
	<PendingAmountHighlight amount={totalPrice} className={className} />
);

PendingTotalPriceHighlight.propTypes = {
	totalPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	className: PropTypes.string,
};
